GoogleMapsApi = require 'app/scripts/lib/google-maps-api'
{ Key, getKey } = require '@trello/keybindings'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
t = require('app/scripts/views/internal/teacup-with-helpers')('card_location')
{ Noun, Verb, trackUe } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'

outerTemplate = t.renderable ->
  t.div ->
    t.input '.js-autofocus.js-location-search', { type: 'text', placeholder: t.l('search-placeholder'), autocomplete: 'off' }

    t.div '.js-results'

resultsTemplate = t.renderable ({ noSearchResults, items, selectedIndex }) ->
  if noSearchResults
    t.p '.empty.plugin-pop-over-search-empty', ->
      t.format 'no-results'
      return

  t.ul '.pop-over-list.js-list.navigable', ->
    for { text, index, placeId } in items
      selected = index == selectedIndex
      t.li { class: t.classify({ selected }) }, ->
        t.a '.js-location-item', { 'data-place-id': placeId }, ->
          t.text text

module.exports = class SetCardLocationPopoverView extends View

  viewTitleKey: ->
    if @model.get('coordinates')
      return 'change location'

    'add location'

  events:
    'keyup .js-location-search': 'keyUp'
    'click .js-location-item': 'setLocation'

  initialize: ->
    GoogleMapsApi.load()
      .then =>
        @render()

  getSessionToken: ->
    @sessionToken ?= GoogleMapsApi.createPlacesSessionToken()

  setLocation: (e) ->
    placeId = @$(e.currentTarget).attr('data-place-id')

    GoogleMapsApi.getPlaceDetails({
      placeId,
      sessionToken: @getSessionToken(),
      fields: [
        'name',
        'geometry.location',
        'formatted_address'
      ]
    }).then (place) =>
      trackUe(Noun.CARD_BACK, Verb.ADDS, Noun.LOCATION, '', '', @options.trackingMethod, {
        idCard: @model.id
        idList: @model.getList().id
        idBoard: @model.getBoard().id
      })

      @model.update({
        coordinates: {
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng()
        },
        locationName: place.name,
        address: place.formatted_address
      })

    PopOver.hide()

  keyUp: (e) ->
    key = getKey(e)

    $list = @$('.js-list')

    if key in [Key.ArrowLeft, Key.ArrowRight]
      return

    if key in [Key.ArrowUp, Key.ArrowDown]
      Util.stop(e)
      Util.navMenuList($list, 'li', key)
      return
    else if key in [Key.Enter, Key.Tab]
      Util.stop(e)
      $list.find('li.selected a').click()
      return

    input = @_searchVal()

    if !input.length
      @$el.find('.js-results').empty()
      return

    GoogleMapsApi.autocomplete({
      input
      sessionToken: @getSessionToken()
    }).then (predictions) =>
        @renderResults(predictions)
      .catch =>
        @renderResults([])

  renderResults: (predictions) ->
    $results = @$el.find('.js-results')

    items = predictions.map (prediction, index) ->
      return {
        index,
        text: prediction.description
        placeId: prediction.place_id
      }

    noSearchResults = !items.length
    selectedIndex = items[0]?.index ? -1

    $results.html(resultsTemplate({ noSearchResults, items, selectedIndex }))

  _searchVal: ->
    @$('.js-location-search').val().trim() ? ""

  render: ->
    @$el.html outerTemplate()

    @
